import * as React from "react";
const ButtonPillSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 7a2 2 0 1 1 0 4H6a2 2 0 1 1 0-4h6ZM6 6a3 3 0 0 0 0 6h6a3 3 0 1 0 0-6H6Z" }));
ButtonPillSmall.displayName = "ButtonPillSmall";
var ButtonPillSmall_default = ButtonPillSmall;
export {
  ButtonPillSmall_default as default
};
